import file from "./file";
import api from "./api";

const UserData = () => api.post("/user");
const OrganisationData = () => api.post("/organisation");
const ResidualFileUpload = (data) => api.post("/residuals/upload", data);
const ResidualFileGet = (data) => api.post("/residuals/get", data);

const ResidualMassFileUpload = (data) =>
  api.post("/residuals/mass/upload", data);

const GetResidualFileBase64 = (data) =>
  api.post("/residuals/getResidualPdf", data);
const ResidualFileDelete = (data) => api.post("/residuals/file/delete", data);
const OrganisationName = (data) => api.post("/organisationname", data);
const Updateinfo = (url, data) => api.post(url, data);
const UserLogin = (payload) => api.post("/stratus/login", payload);
const Logout = () => api.post("/user/logout");
const getPreapp = (query, cancelToken) => api.post("/preapp", query, { cancelToken });
const getPreappById = (data) => api.post("/getPowerappbyId", data);
const getPowerappRawDataForEditing = (data) => api.post(`/get-powerapp-raw-data-for-editing`, data);
const Uploads = (id, data) => api.post("/uploads/" + id, data);
const starApp = (data) => api.post("/star_app", data);
const getUser = (id) => api.get("/getUser/" + id);
const addNotes = (id, data) => api.post("/addnote/" + id, data);
const getTodo = (query) => api.get("/get_todo" + query);
const addTodo = (data) => api.post("/addtodo", data);
const updateTodo = (data) => api.post("/update_todo", data);
const deleteTodo = (id) => api.delete("/delete_todo/" + id);
const checkUser = (id) => api.get("/check-user/");
const updateImportant = (id) => api.post("/update-important/" + id);
const reviveApplication = (data) => api.post("/revive-application", data);
const updateProgression = (data) => api.post("/update-progression", data);
const resendSignature = (data) =>
  api.post("/resend-signature/" + data.id, data);
const getFiles = (data) => api.post("/get-files", data);
const getMerchantInfo = (data) => api.post("/merchant-info", data);
const getActiveBanks = () => api.get("/active-bank-list");
const getBankAddendums = (data) => api.post("/addendum-list", data);
const getBanks = (data) => api.get("/bank-list", { params: data });
const getOrganisationBanks = (data) => api.post("/organisation-bank-list", { params: data });
const addBank = (data) => api.post("/add-bank", data);
const updateBank = (data) => api.post("/update-bank", data);
const addAppBank = (data) => api.post("/add-preapp-bank", data);
const getNotes = (data) => api.post("/get-notes", data);
const deleteNote = (id, data) => api.post("/deleteNote/" + id, data);
const bankList = (data) => api.post("/bank-list", data);
const runPdf = (data) => api.post("/re-run/" + data.id, data);
const sendSignature = (data) => api.post("/send-sign/" + data.id, data);
const confirmSignature = (data) => api.post("/confirm-sign/" + data.id, data);
const cancelApp = (data) => api.post("/cancel-app", data);
const copyApp = (data) => api.post("/copy/" + data.id, data);
const duplicateApp = (data) => api.post("/v2/duplicate-app", data);
const changeOwner = (data) => api.post("/updateownership/" + data.id, data);
const cancelSignature = (data) => api.post("/cancel-sign/" + data.id, data);
const GetAllOrganizationsDropdown = () => api.post("/all-organisation-dropdown");
const GetAllOrganizations = (pageNumber, data = null) =>
  api.post("/all-organisation/?page=" + pageNumber, data);
const ExportAllOrganizations = (data = null) =>
  api.post("/export-organization-csv/", data);
const ExportOrganizationEmails = (data = null) =>
  api.post("/export-organization-emails", data);
const GetAllOrganizationsSingleCall = (pageNumber) =>
  api.get("/all-organisation-single-call");
const GetOrganizationById = (id) => api.get("/get-organisation-by-id/" + id);
const deleteOrganization = (id) => api.post("/delete-organization/" + id);
const SearchOrganizationMembers = (organizationId, params) =>
  api.get("/search-organization-members/" + organizationId, {
    params: params,
  });
const AddMemberToOrganization = (id, data) =>
  api.post("/organizations/" + id + "/agent/add", data);
const CreateOrganization = (data) =>
  api.post("/create-organization", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
const GetAdminUsers = () => api.get("/get-admin-users");
const DeleteMember = (data) => api.post("/delete-member", data);
const UpdateMember = (id, data) => api.post("/update-member/" + id, data);
const UpdateSignatureMember = (data) =>
  api.post("/member/signature/update", data);
const UpdateOrganization = (id, data) =>
  api.post("/update-organization/" + id, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
const UpdateOrganizationWhitelabel = (id, data) =>
  api.post("/update-organization-whitelabel/" + id, data);
const AddCloudflareCustomHostname = (organizationId, data) =>
  api.post("/organizations/" + organizationId + "/whitelabel/cloudflare-custom-hostname", data);
const ListCloudflareCustomHostnames = (organizationId) =>
  api.get("/organizations/" + organizationId + "/whitelabel/cloudflare-custom-hostnames");
const GetCloudflareCustomHostnameDetails = (organizationId, customHostnameId) =>
  api.get("/organizations/" + organizationId + "/whitelabel/cloudflare-custom-hostnames/" + customHostnameId);
const SearchOrganization = (search) =>
  api.get("/search-organization?search=" + search);
const addOrganizationNotes = (id, data) =>
  api.post("/add-organization-note/" + id + "/addnote/", data);
const getOrganizationNotes = (id) => api.post("/organization/get-notes/" + id);
const deleteOrganizationNotes = (id, organization_id) =>
  api.post("/organization/delete-notes/" + id + "/" + organization_id);
const DeleteFile = (data) => api.post("/remove-file", data);
const getZohoList = () => api.post("/get-zoho-users");
const getDepartmentsList = () => api.post("/get-departments-list");
const getOfficeList = (id) => api.post("/organization/get-offices/" + id);
const AddOfficeToOrganization = (id, data) =>
  api.post("/organization/" + id + "/office/add", data);
const UpdateOffice = (organization_id, data) =>
  api.post("/organization/" + organization_id + "/office/update", data);
const DeleteOffice = (data) =>
  api.post("/organization/" + data.organization_id + "/office/delete", data);
const SearchOrganizationOffices = (organizationId, keyword) =>
  api.get("/search-organization-offices/" + organizationId + "?q=" + keyword);
const getBranchesList = (organization_id) =>
  api.post("/office/get-branches/" + organization_id);
const getTemplateList = (organization_id) =>
  api.get("/get-organizations-pricing-templates/" + organization_id);
const AddBranchToOffice = (id, data) =>
  api.post("/office/" + id + "/branch/add", data);
const UpdateBranch = (office_id, data) =>
  api.post("/office/" + office_id + "/branch/update", data);
const DeleteBranch = (data) =>
  api.post("/office/" + data.office_id + "/branch/delete", data);
const DeletePricingTemplate = (id) =>
  api.post("/organization/delete_pricing_template/" + id);
const SearchOfficeBranches = (organizationId, keyword) =>
  api.get("/search-office-branches/" + organizationId + "?q=" + keyword);
const SearchPricingTemplate = (organizationId, keyword) =>
  api.get("/search-pricing-template/" + organizationId + "?q=" + keyword);
const UpdatePricingTemplate = (data) =>
  api.post("/update-pricing-templates", data);
const GetAllAgents = () => api.get("/list-all-agents");
const updatePartnerResidualSplitsDetails = (id, data) =>
  api.post("/residuals/partner/split/" + id + "/detail", data);
const getPartnerResidualSplits = (id) =>
  api.get("/residuals/partner/split/" + id);
const deleteResidualData = (payload) => api.post("/residuals/delete", payload);
const getResidualData = (payload) => api.post("/residuals/data", payload);
const getTempResidualData = (payload) =>
  api.post("/residuals/data/temp", payload);
const getLatestResidualData = (payload) =>
  api.post("/residuals/latest/months", payload);
const getExportCSVLink = (query) => file("/export-csv", query);
const GetEmailData = (slug) => api.get(`/get_email_info/?slug=${slug}`);
const SendLink = (data) => api.post("/send_link/", data);
const GetData = (editSlug) => api.get("/get-data/?editSlug=" + editSlug);
const SendService = (data) => api.post('/send_service', data);
const ListOfPdfs = () => api.get('/list_of_pdfs');
const FlattenListOfPdfs = () => api.get('/flattened_list_of_pdfs');
const generatePDFAndDownload = (data) => api.post('/generate_pdf/download', data);
const EmsBankFiles = (id) => api.get(`/ems_bank_files/${id}`);

const SendServiceHistory = (id) => api.get(`send_service_history/${id}`);
const UpdateMccRecord = (payload) => api.post("/update_mcc_record", payload);

const CreateApplication = (data) => api.post("/save-application", data);
const CreatePrevetApplication = (data) =>
  api.post("/save-prevet-application", data);
const ChangePrevetApplicationStatus = (data) =>
  api.post("/change-prevet-status", data);

const getProcessingAppData = (date) =>
  api.get(
    "/get-processing-app-data?startDate=" +
    date.firstDate +
    "&endDate=" +
    date.lastDate +
    "&usertype=" +
    date.user,
  );
const saveGoals = (data) => api.post("/set-goals", data);
const getGoalData = (data, abortController) => api.post("daily-goal-data", data, {
  signal: abortController?.signal,
});
const getAppMetricsData = (data) => api.post("app-metrics-data", data);
const saveDashboardState = (data) => api.post("save-dashboard-state", data);
const getAnalyticsData = (data) => api.post("analytics-data", data);

const SaveUpdateEquipmentTemplate = (data) =>
  api.post("/save-update-equipment-template", data);
const GetEquipmentTemplate = (data) =>
  api.post("/get-equipment-template", data);
const DeleteEquipmentTemplate = (id) =>
  api.delete("/remove-equipment-template/" + id);
const SaveUpdatePricingEquipmentTemplate = (data) =>
  api.post("/save-update-pricing-equipment-template", data);
const GetPricingEquipmentTemplate = (data) =>
  api.post("/get-pricing-equipment-template", data);
const GetPricingEquipmentTemplateById = (id) =>
  api.get("/get-pricing-equipment-template-by-id/" + id);
const DeletePricingEquipmentTemplate = (id) =>
  api.delete("/remove-pricing-equipment-template/" + id);
const SendResetPasswordEmail = (data) =>
  api.post("/send-reset-password-email", data);
const ResetPasswordTokenVerify = (data) =>
  api.post("/reset-password-token-verify", data);
const ResetPassword = (data) => api.post("/reset-password", data);
const blankApp = (data) => api.post("blank-app", data);
const getDropUsers = (data) => api.post("/dropdown-users", data);
const GetMccList = (data) => api.post("/get-mcc-list", data);
const ResetPasswordByPcAdmin = (data) =>
  api.post("/reset-pass-by-pc-admin", data);
const orgUsers = () => api.get("/org-filter-users");
const leadOwners = () => api.get("/org-lead-owners");
const retentionReport = (data) => api.post("/retention/report", data);
const UpdateApproval = (data) => api.post("/update-approval", data);
const saveWebhook = (data) => api.post("webhook/save", data);
const logWebHook = (data) => api.post("webhook/logs", data);
const generateWebhookSecret = (data) =>
  api.post("webhook/generate-secret", data);

const MccListWithPaginate = (pageNumber, data = null) =>
  api.post("/mcc/list/?page=" + pageNumber, data);
const ExportMccList = (data = null) => file("/mcc/export", data);
const TemplateListWithPaginate = (pageNumber, data = null) =>
  api.post("/template/list/?page=" + pageNumber, data);
// Pricing Templates API functions
const cloneTemplate = (data) => api.post('template/clone', data);
const AddUpdateMcc = (data) => api.post("/mcc/update", data);
const RemoveMcc = (id) => api.delete("/mcc/remove/" + id);
const updateZohoData = (data) => api.post("/update-zoho-data", data);
const updateUwData = (data) => api.post("/update-uw-data", data);

const OrgContractList = (data) => api.post("org-contract/list", data);
const AddOrgContract = (data) => api.post("org-contract/store", data);
const RemoveOrgContract = (id) => api.delete("org-contract/remove/" + id);
const GetFileBase64 = (id) => api.get("org-contract/get-file-base64/" + id);
const getUserToMention = (data) => api.post("/get-user-to-mention", data);
const getPricingTemplate = (data) => api.post("get-pricing-template", data);
const undoNote = (data) => api.post("undo-note", data);
const GetUserDetailsById = (id) => api.get("get-user-details-by-id/" + id);
const getAppFileData = (id) => api.get("/get-app-file-data/" + id);

const getProgressionList = () => api.get("/progression-list");
const changeOtpMobileNumber = (data) =>
  api.post("/update-otp-mobile-number", data);
const changeSignerEmail = (data) => api.post("/update-signer-email", data);
const overrideBankDetails = (data) => api.post("/override-bank-details", data);
const GetMCCRecordById = (id) => api.get("/get/mcc/" + id);
const GetBatchData = (data) => api.post("/ems/get-batch-data", data);
const GetTransactionData = (data) => api.post("/ems/transaction/data", data);
const getSubOrganizations = (organization_id, params = {}) =>
  api.get("sub-organizations", { params: { organization_id, ...params } });
const saveSubOrganizations = (data) => api.post("sub-organizations", data);
const updateSubOrganizations = (data) => api.post("edit-sub-organizations", data);
const getSubOrganizationById = (id) => api.get("get-sub-organisation-by-id/" + id);
const searchSubOrg = (data) => api.post("search-sub-org", data);
const saveBankProcess = (data) => api.post("bank-processors", data);
const getEmsOffices = (search, page) => api.get("ems-offices", { params: { search, page } });
const getAllEmsOffices = () => api.get("ems-offices", { params: { all: 1 } });
const getUserBranchesList = () => api.post("get-branches-list");
const getEmsOfficesById = (search, page) => api.get("ems-offices-by-id", { params: { search, page } });
const assignPETemplate = (data) => api.post("assign-pe-template", data);

const getEmsRepCodes = () => api.get("ems/get-rep-codes");

const getEmsOfficesByUser = (user_id) =>
  api.get(`ems-offices-by-user/${user_id}`);

//EMS
const getMonthlyBatchSales = (data) =>
  api.post("ems/get-monthly-batch-sales", data);
const transactionLineChart = (data) =>
  api.post("ems/get-transaction-line-chart-data", data);
const getPieChartData = (data) => api.post("ems/get-pie-chart-data", data);
const saveMid = (data) => api.post("ems/save-mid", data);
const getMerchantDetails = (data) => api.post("ems/get-merchant-details", data);
const getMerchantFilterBounds = (data, abortController) => api.post("/v2/merchants/filter-bounds", data, {
  signal: abortController?.signal
});
const getMerchantStatement = (data) =>
  api.post("ems/get-merchant-statement", data);

const updateVarSheet = (data, id) => api.post(`update-var-sheet/${id}`, data);
const getVarSheet = (id) => api.post(`get-var-sheet/${id}`);
const getVarSheetTemplates = () => api.get('var-sheet-templates');
const downloadVarSheet = (powerappId, data) => api.post(`download-var-sheet/${powerappId}`, data, { responseType: 'blob' });
const emsBoot = (data) => api.post("ems/ems-boot", data);
const getEmsBootEquipments = (org_id) =>
  api.get("equipments-for-ems-boot", { params: org_id });
const createEMSBootApp = (data) => api.post("ems/ems-boot/create-app", data);
const createEMSBootAppV2 = (data) => api.post("ems/ems-boot/create-app-v2", data);
const assignPEToApp = (data) => api.post("attach-pricing-equipment", data);
const saveTemplates = (data) => api.post("save-templates", data);
const saveTemplateV2 = (data) => api.post("v2/save-template", data);
const getTemplateById = (id) => api.get(`get-template-by-id/${id}`);
const saveAvailableForTemplates = (data) => api.post("save-available-for-template", data);

const deleteTemplate = (data) => api.post("delete-template", data);

const saveUpdateEquipments = (data) => api.post("save-update-equipments", data);
const getEquipments = (data) => api.get("get-equipments", { params: data });
const getEquipmentsV2 = (data, abortController) => api.get("get-equipments", { params: data, signal: abortController?.signal });
const deleteEquipments = (data) => api.post("equipment", data);

const addEquipmentCategory = (data) => api.post("equipment/category", data);
const deleteEquipmentCategory = (id) =>
  api.post("equipment/category/delete", { id });
const getEquipmentCategory = () => api.get("equipment/category");

const saveEquipmentBrand = (data) => api.post("save-equipment-brand", data);
const getEquipmentBrand = (data) =>
  api.get("get-equipment-brands", { params: data });
const getEquipmentBrandV2 = (data, abortController) =>
  api.get("get-equipment-brands", { params: data, signal: abortController?.signal });
const deleteEquipmentBrand = (data) =>
  api.post("delete-equipment-brands", data);
const cancelMultipleApp = (data) => api.post("/cancel-multiple-app", data);
const changeMultipleOwner = (data) =>
  api.post("/change-owner-multiple-app", data);
const deleteBulkApps = (data) => api.post("/delete-powerapps", data);
const saveOrgEquipment = (data) => api.post("save-org-equipment", data);
const bulkBankDeactivate = (data) => api.post("bulk-bank-deactivate", data);
const getTemplateForApplication = () => api.get("get-template-for-application");
const SearchOrganizations = (data) => api.get("search-organizations", { params: data });
const SearchUsers = (data) => api.get("search-users", { params: data });

// mcc bulk actions
const mccBulkRemove = (data) => api.post("/mcc/bulk-remove", data);
const mccBulkUpdate = (data) => api.post("/mcc/bulk-update", data);

// v2 routes
const getApplicationData = (editSlug, config = {}) => api.get(`/v2/get-data/${editSlug}`, config);
const organisationImage = (agent_url) => api.get(`organization/image/${agent_url}`);
const getMccLowRisk = (data) => api.post("/v2/get-mcc-low-risk", data);
const salesAppPost = (data, config = {}) => api.post("/v2/sales-app-post", data, config);
const getMinimumData = (editSlug) => api.get(`/v2/get-minimum-data/${editSlug}`);
const sendOtp = (editSlug, data) => api.post(`/v2/send-otp/${editSlug}`, data);
const verifyOtp = (editSlug, data) => api.post(`/v2/verify-otp/${editSlug}`, data);
const getCountries = () => api.get("/v2/get-countries");
const getPdfStatus = (data) => api.post("/v2/get-pdf-status", data);
const uploadPdf = (editSlug, data, config = {}) => api.post(`/v2/upload-pdf/${editSlug}`, data, config);
const reUploadPdf = (editSlug, data, config = {}) => api.post(`/v2/re-upload-pdf/${editSlug}`, data, config);
const uploadSignature = (editSlug, data, config = {}) => api.post(`/v2/upload-signature/${editSlug}`, data, config);
const uploadApplicationFiles = (data, config = {}) => api.post("/v2/upload-application-files", data, config);
const getUploadedFiles = (data) => api.post("/v2/get-uploaded-files", data);
const deleteUploadedFile = (data) => api.post("/v2/delete-uploaded-file", data);
const getNotesThankyou = (data) => api.post("/v2/get-notes-thankyou", data);
const addNoteThankyou = (data, config = {}) => api.post("/v2/add-note-thankyou", data, config);
const undoNoteThankyou = (data) => api.post("/v2/undo-note-thankyou", data);

// dashboard
const getApplicationsData = (data) => api.post("/v2/dashboard/get-applications-data", data);
const getDashboardStatsData = (data) => api.post("/v2/dashboard/get-stats-data", data);
const getActiveMerchants = (data) => api.post("/v2/dashboard/active-merchants", data);
const getTopChargebacks = (data) => api.post("/v2/dashboard/top-chargebacks", data);
const getPortfolioVolume = (data) => api.post("/v2/dashboard/portfolio-volume", data);
const getAttritionData = (data) => api.post("/v2/dashboard/attrition-data", data);
const getTopResidual = (data) => api.post("/v2/dashboard/top-residual", data);
// const getIndustriesData = (data) => api.post("/v2/dashboard/get-industries-data", data);
const getUserPortfolioSetting = () => api.get("/v2/dashboard/get-user-portfolio-setting");
const saveUserPortfolioSetting = (data) => api.post("/v2/dashboard/save-user-portfolio-setting", data);
const getIndustriesData = (data, abortController) =>
  api.post("/v2/dashboard/get-industries-data", data, {
    signal: abortController?.signal
  });
const submitAdditionalDocuments = (data, config = {}) => api.post("/v2/submit-additional-documents", data, config);
const getNotificationEvents = (abortController) => api.get("/v2/notification-events", {
  signal: abortController?.signal
});
const getUserNotificationSettings = (abortController) => api.get("/v2/user/notification-settings", {
  signal: abortController?.signal
});
const saveUserNotificationSetting = (data, abortController) => api.put("/v2/user/notification-settings", data, {
  signal: abortController?.signal
});
const getTransactionLineChartData = (data) => api.post("/v2/transaction/line-chart-data", data);
const getTransactionCardSummaryChartData = (data) => api.post("/v2/transaction/card-summary", data);
const getChargebackVolume = (data, abortController) => api.post("/v2/chargeback/volume", data, {
  signal: abortController?.signal
});

// Profile Notification
const getProfileNotifications = (data) => api.get("/v2/list-profile-notifications?page=" + data?.page , data);
const markAsReadProfileNotification = (id, data) => api.put(`/v2/profile-notifications/${id}/read`, data);
const markAllReadProfileNotification = () => api.put("/v2/profile-notifications/mark-all-read");
const dismissProfileNotification = (id) => api.delete(`/v2/profile-notifications/${id}`);
const dismissAllProfileNotifications = () => api.delete("/v2/profile-notifications");

// Batch and Chargeback APIs
const getMerchantBatchData = (data) => api.post("v2/batch/data", data);
const getMerchantBatchDataExport = (data) => file("/v2/batch/data", data);
const getMerchantBatchCardSummary = (data) => api.post("v2/batch/card-summary", data);
const getMerchantChargebackData = (data) => api.post("v2/chargeback/data", data);
const getMerchantChargebackDataExport = (data) => file("/v2/chargeback/data", data);
const getMerchantDepositData = (data) => api.post("v2/merchant/deposit", data);
const getMerchantDepositDetailData = (data) => api.post("v2/merchant/deposit-detail", data);
const getMerchantInterchangeData = (data) => api.post("v2/merchant/interchange", data);
const getMerchantResidualsDetail = (data) =>
  api.post("v2/merchant/residuals-detail", data);
const getChargebackScoreboard = (data, abortController) =>
  api.post("v2/chargeback/scoreboard", data, {
    signal: abortController?.signal,
  });
const getChargebackPageData = (data) => api.post("/v2/chargeback-page/data", data);
const getChargebackPageDataExport = (data) => file("/v2/chargeback-page/data", data);
const getChargebackPageDetails = (dashId) =>
  api.post(`/v2/chargeback-page/details/${dashId}`);
const getChargebackPageStats = (data) => api.post("/v2/chargeback-page/stats", {
  startDate: data.startDate,
  endDate: data.endDate,
  orgFilter: data.orgFilter
});

const getCBFilterData = (data) => api.post("/v2/chargeback-page/filter-data");

const getRetrievalData = (data) => api.post("v2/merchant/retrieval", data);
const getOrgList = (data, cancelToken) => api.post("v2/organization/list", data, { cancelToken });
const getSubOrgList = (data) => api.post("v2/organization/sub-org-list", data);
const getMerchantDetailWithTrends = (data) => api.post("v2/merchant/details", data);

export const saveEditedSubmissionData = async (editslug, data) => api.post(`v2/edit-submission-data/${editslug}`, data);

export const getAnetConfig = () => api.get("/api/anet/config");
export const approveAnetApplication = (powerappId, data) => api.post(`/api/anet/approve/${powerappId}`, data);
export const updateAnetApplicationStatus = (powerappId, data) => api.post(`/api/anet/update-status/${powerappId}`, data);

// Pricing Defaults API functions
const getOrganizationPricingDefaults = (organizationId) => 
  api.get(`/organizations/${organizationId}/pricing-defaults`);

const getActivePricingModels = (organizationId) => 
  api.get(`/organizations/${organizationId}/pricing-defaults/active-models`);

const setActivePricingModels = (organizationId, activeModels) => 
  api.put(`/organizations/${organizationId}/pricing-defaults/active-models`, { active_pricing_models: activeModels });

const setPricingModelDefaults = (organizationId, pricingModel, defaults) => 
  api.post(`/organizations/${organizationId}/pricing-defaults`, { pricing_model: pricingModel, defaults });

const setSharedDefaults = (organizationId, sharedType, defaults) => 
  api.post(`/organizations/${organizationId}/pricing-defaults/shared`, { shared_type: sharedType, defaults });

const getSystemDefaults = (pricingModel) => 
  api.get(`/pricing-defaults/system/${pricingModel}`);

const getCommonDefaults = () => 
  api.get(`/pricing-defaults/common`);

const updateCommonDefaults = (organizationId, commonDefaults) => 
  api.put(`/organizations/${organizationId}/pricing-defaults/common`, { common_defaults: commonDefaults });

const updateDefaultFees = (organizationId, defaultFees) => 
  api.put(`/organizations/${organizationId}/pricing-defaults/default-fees`, { default_fees: defaultFees });

const getActivePricingModelNames = (organizationId) => 
  api.get(`/organizations/${organizationId}/pricing-defaults/active-model-names`);
// service ticket
const getServiceTicketOptions = () => api.get("v2/service-ticket/get-all-options");
const createServiceTicket = (data, config = {}) => api.post("v2/service-ticket/create", data, config);
const addTicketComment = (data, config = {}) => api.post("v2/service-ticket/add-comment", data, config);
const getTicketList = (data) => api.post("v2/service-ticket/list", data);
const searchByDba = (data) => api.post("v2/powerapp/search-by-dba", data);
const getTicketDetails = (data) => api.post("v2/service-ticket/ticket-details", data);
const getApplicationsTickets = (data) => api.post("v2/service-ticket/get-applications-tickets", data); 

// Shipping APIs
const getShippingList = (data, config = {}) => api.post("v2/shipping/list", data, config);
const getShippingFilterOptions = (data = {}) => api.post("v2/shipping/filter-options", data); 

// New Residual APIs
const getResidualPortfolio = (data) => api.post('v2/residual/portfolio', data);
const getResidualVolume = (data) => api.post('v2/residual/volume', data);
const getResidualScorecard = (data) => api.post('v2/residual/scorecard', data);
const getResidualDataV2 = (data) => api.post('v2/residual/data', data);
const getResidualDataV2Export = (data) => file('/v2/residual/data', data);
const getResidualFilterData = () => api.post('v2/residual/filter-data');
const getPaymentAuthorizationReport = (params) =>
  api.get("/residuals/reports/payment-authorizations", { params });
const getAgentAccountStatementReport = (params) =>
  api.get("/residuals/reports/agent-account-statements", { params });

// Manager Approval APIs
const getPowerappsWithApprovalCounts = ({ params }) => api.get("/manager-approvals/v2/powerapps", { params });
const getPowerappApprovals = ({ powerappId, params }) => api.get(`/manager-approvals/v2/powerapp/${powerappId}/approvals`, { params });
const getArchivedApprovals = ({ params }) => api.get("/manager-approvals/v2/archived", { params });
const approveManagerApproval = (data) => api.post("/manager-approvals/v2/approve", data);
const declineManagerApproval = (data) => api.post("/manager-approvals/v2/decline", data);
const getApprovalHistory = ({ params }) => api.get("/manager-approvals/v2/history", { params });
const getApprovalStatus = ({ powerappId, params }) => api.get(`/manager-approvals/v2/powerapp/${powerappId}/approval-status`, { params });

// Agent Approval APIs
const getAgentPowerappsWithApprovals = ({ params }) => api.get("/agent-approvals/v2/powerapps", { params });
const getAgentPowerappApprovals = ({ powerappId, params }) => api.get(`/agent-approvals/v2/powerapp/${powerappId}/approvals`, { params });

const signatureLocations = (data) => api.post('signature-locations', data);
// v2 routes end
// ems offices
const getEMSOffices = (data) => api.post("v2/get-ems-offices", data);
const AddUpdateEMSOffice = (data) => api.post("v2/add-update-ems-office", data);

const matchOldPassword = (data) => api.post("match-old-password", data);
const updatePassword = (data) => api.post("update-password", data);
const getUserProfile = () => api.get("user-profile");
const updateUserProfile = (data) => api.post("update-user-profile", data);
const validateRoutingNumber = (data) =>
  api.post("/ems/validation/routing-number", data);
const validateDrivingLicenseNumber = (data) =>
  api.post("/ems/validation/driving-license", data);
const validatePhoneNumber = (data) =>
  api.post("/ems/validation/phone-number", data);

const addEditPricingEquipment = (data) => api.post("v2/add-edit-pricing-equipment", data);

const finicityConnect = (data) => api.post("finicity-connect", data);       
const finicitySuccess = (data) => api.post("finicity-success", data);       
const plaidConnect = (data, config = {}) => api.post("plaid-connect", data, config);
const plaidSuccess = (data, config = {}) => api.post("plaid-success", data, config);
const plaidIdvConnect = (data, config = {}) => api.post("plaid-idv-connect", data, config);
const plaidIdvSuccess = (data, config = {}) => api.post("plaid-idv-success", data, config);
const sendApplicationLinkToMerchant = (editslug, data = {}) => api.post(`v2/applications/${editslug}/merchant-link/send`, data);

// Announcements
const getAnnouncements = () => api.get("/v2/announcements");
const getAllAnnouncements = (data) => api.get("/v2/announcements/all", { params: data });
const saveAnnouncement = (data) => api.post("/v2/announcements", data);
const updateAnnouncement = (id, data) => api.put(`/v2/announcements/${id}`, data);
const deleteAnnouncement = (id) => api.delete(`/v2/announcements/${id}`);
const dismissAnnouncement = (id) => api.post(`/v2/announcements/${id}/dismiss`);
// Saved Filters
const getSavedFilters = (page) => api.get("/v2/saved-filters", { params: { page } });
const createSavedFilter = (data) => api.post("/v2/saved-filters", data);
const updateSavedFilter = (id, data) => api.put(`/v2/saved-filters/${id}`, data);
const deleteSavedFilter = (id) => api.delete(`/v2/saved-filters/${id}`);
// API Token management
const getApiTokens = () => api.get("api-tokens");
const createApiToken = (data) => api.post("api-tokens", data);
const deleteApiToken = (id) => api.delete(`api-tokens/${id}`);

// Two-factor authentication
const get2faStatus = () => api.get("2fa/status");
const setup2fa = (data) => api.post("2fa/setup", data);
const manualKey2fa = (data) => api.post("2fa/manual-key", data);
const enable2fa = (data) => api.post("2fa/enable", data);
const disable2fa = (data) => api.post("2fa/disable", data);
const validate2fa = (data) => api.post("2fa/validate", data);

// Phone (cell) verification over SMS
const sendPhoneVerificationCode = (data) => api.post("user/phone-verification/send", data);
const verifyPhoneVerificationCode = (data) => api.post("user/phone-verification/verify", data);
// Login-time SMS challenge (no session yet — identified by phone_otp_token)
const validatePhoneLoginOtp = (data) => api.post("phone-otp/validate", data);
const resendPhoneLoginOtp = (data) => api.post("phone-otp/resend", data);
const saveCbdAddendum = (data, config = {}) => api.post("v2/conditional-addendums/cbd", data, config);
const saveVapeAttestationAddendum = (data) => api.post("v2/conditional-addendums/vape-attestation", data);
const saveTravelAddendum = (data) => api.post("v2/conditional-addendums/travel-addendum", data);

const UploadPaylianceDocumentApi = (data) => api.post("payliance/upload-document", data);

export {
  UserData,
  finicityConnect,
  finicitySuccess,
  plaidConnect,
  plaidSuccess,
  plaidIdvConnect,
  plaidIdvSuccess,
  OrganisationData,
  ResidualFileUpload,
  ResidualFileGet,
  ResidualMassFileUpload,
  GetResidualFileBase64,
  ResidualFileDelete,
  OrganisationName,
  Updateinfo,
  UserLogin,
  Logout,
  organisationImage,
  getPreapp,
  getPreappById,
  getPowerappRawDataForEditing,
  Uploads,
  starApp,
  getUser,
  addNotes,
  deleteNote,
  getTodo,
  addTodo,
  updateTodo,
  deleteTodo,
  checkUser,
  updateImportant,
  updateProgression,
  resendSignature,
  reviveApplication,
  getFiles,
  getMerchantInfo,
  getActiveBanks,
  getBankAddendums,
  getBanks,
  getOrganisationBanks,
  addBank,
  updateBank,
  addAppBank,
  getNotes,
  bankList,
  runPdf,
  copyApp,
  duplicateApp,
  changeOwner,
  sendSignature,
  confirmSignature,
  cancelApp,
  cancelSignature,
  GetAllOrganizationsDropdown,
  GetAllOrganizations,
  ExportAllOrganizations,
  GetOrganizationById,
  SearchOrganizationMembers,
  AddMemberToOrganization,
  CreateOrganization,
  GetAdminUsers,
  DeleteMember,
  UpdateMember,
  UpdateSignatureMember,
  UpdateOrganization,
  UpdateOrganizationWhitelabel,
  AddCloudflareCustomHostname,
  ListCloudflareCustomHostnames,
  GetCloudflareCustomHostnameDetails,
  SearchOrganization,
  addOrganizationNotes,
  getOrganizationNotes,
  deleteOrganizationNotes,
  deleteOrganization,
  DeleteFile,
  getZohoList,
  getDepartmentsList,
  getOfficeList,
  AddOfficeToOrganization,
  UpdateOffice,
  DeleteOffice,
  SearchOrganizationOffices,
  getBranchesList,
  getTemplateList,
  AddBranchToOffice,
  UpdateBranch,
  DeleteBranch,
  DeletePricingTemplate,
  SearchOfficeBranches,
  SearchPricingTemplate,
  GetAllOrganizationsSingleCall,
  updatePartnerResidualSplitsDetails,
  getPartnerResidualSplits,
  getLatestResidualData,
  deleteResidualData,
  getExportCSVLink,
  getResidualData,
  GetEmailData,
  SendLink,
  GetData,
  getProcessingAppData,
  saveGoals,
  getGoalData,
  getAppMetricsData,
  GetAllAgents,
  saveDashboardState,
  getAnalyticsData,
  UpdatePricingTemplate,
  getTempResidualData,
  SaveUpdateEquipmentTemplate,
  GetEquipmentTemplate,
  DeleteEquipmentTemplate,
  GetPricingEquipmentTemplate,
  GetPricingEquipmentTemplateById,
  DeletePricingEquipmentTemplate,
  SaveUpdatePricingEquipmentTemplate,
  SendResetPasswordEmail,
  ResetPasswordTokenVerify,
  ResetPassword,
  CreateApplication,
  CreatePrevetApplication,
  ChangePrevetApplicationStatus,
  blankApp,
  getDropUsers,
  GetMccList,
  ResetPasswordByPcAdmin,
  orgUsers,
  retentionReport,
  UpdateApproval,
  saveWebhook,
  logWebHook,
  generateWebhookSecret,
  MccListWithPaginate,
  ExportMccList,
  TemplateListWithPaginate,
  cloneTemplate,
  AddUpdateMcc,
  RemoveMcc,
  SendService,
  ListOfPdfs,
  FlattenListOfPdfs,
  generatePDFAndDownload,
  SendServiceHistory,
  UpdateMccRecord,
  OrgContractList,
  AddOrgContract,
  RemoveOrgContract,
  updateZohoData,
  updateUwData,
  GetFileBase64,
  getUserToMention,
  getPricingTemplate,
  undoNote,
  GetUserDetailsById,
  getAppFileData,
  saveUpdateEquipments,
  getEquipments,
  getEquipmentsV2,
  deleteEquipments,
  ExportOrganizationEmails,
  getProgressionList,
  changeOtpMobileNumber,
  changeSignerEmail,
  overrideBankDetails,
  leadOwners,
  GetMCCRecordById,
  GetBatchData,
  GetTransactionData,
  getSubOrganizations,
  saveSubOrganizations,
  updateSubOrganizations,
  getSubOrganizationById,
  searchSubOrg,
  saveBankProcess,
  getEmsOffices,
  getAllEmsOffices,
  getUserBranchesList,
  getEmsOfficesById,
  assignPETemplate,
  getEmsOfficesByUser,
  getMonthlyBatchSales,
  transactionLineChart,
  getPieChartData,
  saveMid,
  getMerchantDetails,
  getMerchantStatement,
  updateVarSheet,
  getVarSheet,
  getVarSheetTemplates,
  downloadVarSheet,
  emsBoot,
  getEmsBootEquipments,
  saveTemplates,
  saveAvailableForTemplates,
  deleteTemplate,
  createEMSBootApp,
  createEMSBootAppV2,
  assignPEToApp,
  addEquipmentCategory,
  getEquipmentCategory,
  deleteEquipmentCategory,
  saveEquipmentBrand,
  getEquipmentBrand,
  getEquipmentBrandV2,
  deleteEquipmentBrand,
  cancelMultipleApp,
  changeMultipleOwner,
  deleteBulkApps,
  EmsBankFiles,
  saveOrgEquipment,
  bulkBankDeactivate,
  mccBulkRemove,
  mccBulkUpdate,
  getEmsRepCodes,
  getApplicationData,
  getMccLowRisk,
  salesAppPost,
  getMinimumData,
  sendOtp,
  verifyOtp,
  getCountries,
  getPdfStatus,
  uploadPdf,
  uploadSignature,
  reUploadPdf,
  uploadApplicationFiles,
  getUploadedFiles,
  deleteUploadedFile,
  getNotesThankyou,
  addNoteThankyou,
  undoNoteThankyou,
  saveTemplateV2,
  getTemplateById,
  getTemplateForApplication,
  getApplicationsData,
  getDashboardStatsData,
  getIndustriesData,
  submitAdditionalDocuments,
  getMerchantBatchCardSummary,
  getMerchantChargebackData,
  getMerchantChargebackDataExport,
  getMerchantBatchData,
  getMerchantBatchDataExport,
  getNotificationEvents,
  getUserNotificationSettings,
  saveUserNotificationSetting,  
  getProfileNotifications,
  markAsReadProfileNotification,
  markAllReadProfileNotification,
  dismissProfileNotification,
  dismissAllProfileNotifications,
  SearchOrganizations,
  SearchUsers,
  getActiveMerchants,
  getTopChargebacks,
  getTransactionLineChartData,
  getPortfolioVolume,
  getTransactionCardSummaryChartData,
  getOrganizationPricingDefaults,
  getActivePricingModels,
  setActivePricingModels,
  setPricingModelDefaults,
  setSharedDefaults,
  getSystemDefaults,
  getCommonDefaults,
  updateCommonDefaults,
  updateDefaultFees,
  getActivePricingModelNames,
  getChargebackVolume,
  getMerchantDepositData,
  getMerchantDepositDetailData,
  getMerchantInterchangeData,
  getMerchantResidualsDetail,
  getChargebackScoreboard,
  getChargebackPageData,
  getChargebackPageDetails,
  getChargebackPageStats,
  getMerchantFilterBounds,
  getRetrievalData,
  getOrgList,
  getMerchantDetailWithTrends,
  getCBFilterData,
  getSubOrgList,
  getServiceTicketOptions,
  createServiceTicket,
  addTicketComment,
  getTicketList,
  searchByDba,
  getTicketDetails,
  getApplicationsTickets,
  getShippingList,
  getShippingFilterOptions,
  getAttritionData,
  getTopResidual,
  getUserPortfolioSetting,
  saveUserPortfolioSetting,
  getResidualPortfolio,
  getResidualVolume,
  getResidualScorecard,
  getResidualDataV2,
  getResidualDataV2Export,
  getResidualFilterData,
  getPaymentAuthorizationReport,
  getAgentAccountStatementReport,
  getPowerappsWithApprovalCounts,
  getPowerappApprovals,
  getArchivedApprovals,
  approveManagerApproval,
  declineManagerApproval,
  getApprovalHistory,
  getApprovalStatus,
  getAgentPowerappsWithApprovals,
  getAgentPowerappApprovals,
  signatureLocations,
  getEMSOffices,
  AddUpdateEMSOffice,
  matchOldPassword,
  updatePassword,
  getUserProfile,
  updateUserProfile,
  validateRoutingNumber,
  validateDrivingLicenseNumber,
  validatePhoneNumber,
  addEditPricingEquipment,
  getChargebackPageDataExport,
  sendApplicationLinkToMerchant,
  getAnnouncements,
  getAllAnnouncements,
  saveAnnouncement,
  updateAnnouncement,
  deleteAnnouncement,
  dismissAnnouncement,
  getSavedFilters,
  createSavedFilter,
  updateSavedFilter,
  deleteSavedFilter,
  getApiTokens,
  createApiToken,
  deleteApiToken,
  get2faStatus,
  setup2fa,
  manualKey2fa,
  enable2fa,
  disable2fa,
  validate2fa,
  sendPhoneVerificationCode,
  verifyPhoneVerificationCode,
  validatePhoneLoginOtp,
  resendPhoneLoginOtp,
  saveCbdAddendum,
  saveVapeAttestationAddendum,
  saveTravelAddendum,
  UploadPaylianceDocumentApi,
};
